<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="bg-primary">
    <div class="section-container">
      <div class="container mx-auto px-0">
        <div class="grid md:grid-cols-2 items-stretch">
          <!-- Left Side: Timeline Content -->
          <div class="bg-white p-12 flex flex-col justify-center">
            <h2 class="text-4xl mb-10 pb-2">{{ t("Waarom Zorgblik?") }}</h2>

            <div class="relative border-l-4 border-gray-300 pl-6 space-y-12">
              <!-- Step 1 -->
              <div class="relative flex items-center">
                <div
                  class="absolute -left-[44px] w-10 h-10 flex items-center justify-center bg-[#437066] text-white text-lg font-bold rounded-md shadow-md border-2 border-white"
                >1</div>
                <div class="absolute -left-2 top-1/2 w-6 h-[2px] bg-gray-400"></div>
                <div class="ml-4">
                  <h3 class="text-xl font-semibold">{{ t("Vooruitstrevend") }}</h3>
                  <p>{{ t("Altijd inspelen op maatschappelijke veranderingen. We blijven investeren in innovaties om de toekomst van de zorg vorm te geven.") }}</p>
                </div>
              </div>

              <!-- Step 2 -->
              <div class="relative flex items-center">
                <div
                  class="absolute -left-[44px] w-10 h-10 flex items-center justify-center bg-[#437066] text-white text-lg font-semibold rounded-md shadow-md border-2 border-white"
                >2</div>
                <div class="absolute -left-2 top-1/2 w-6 h-[2px] bg-gray-400"></div>
                <div class="ml-4">
                  <h3 class="text-xl font-semibold">{{ t("Professionele groei") }}</h3>
                  <p>{{ t("We helpen je bij het ontwikkelen van jouw carrière in de zorg. We bieden je de middelen en ondersteuning die je nodig hebt om te groeien en te excelleren.") }}</p>
                </div>
              </div>

              <!-- Step 3 -->
              <div class="relative flex items-center">
                <div
                  class="absolute -left-[44px] w-10 h-10 flex items-center justify-center bg-[#437066] text-white text-lg font-semibold rounded-md shadow-md border-2 border-white"
                >3</div>
                <div class="absolute -left-2 top-1/2 w-6 h-[2px] bg-gray-400"></div>
                <div class="ml-4">
                  <h3 class="text-xl font-semibold">{{ t("Toegankelijkheid") }}</h3>
                  <p>{{ t("We maken onze cursussen toegankelijk voor iedereen, ongeacht hun achtergrond of ervaring. We bieden verschillende leerniveaus en ondersteuning om je te helpen slagen.") }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Side: Background Image -->
          <div class="w-full h-full">
            <img
              :alt="$t('Pointing arrow to steps')"
              src="@/../img/home/nature.jpg"
              class="w-full h-full object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>